module.exports = __webpack_public_path__ + "static/media/Hotel Single Bed 1.826d8647.svg";